import { createSlice } from "@reduxjs/toolkit";
import apiService from "../../api/apiService";
import { formatAxiosErrorMessage } from "../../utils/common";
import { endPoints } from "../../api/endpoints";
import { apiUrlBuilder } from "../../utils/util";

const OrderManagementInitialState = {
    configuration: {
        isLoading: false,
        data: null,
        error: null,
    },
    createConfiguration: {
        isLoading: false,
        data: null,
        error: null,
    },
    deleteConfiguration: {
        isLoading: false,
        data: null,
        error: null,
    },
};

export const OrderManagementSlice = createSlice({
    name: "orderManagementIntegration",
    initialState: { ...OrderManagementInitialState },
    reducers: {
        OrderMgmtConfigurationRequesting: (state) => {
            state.configuration.isLoading = true;
        },
        OrderMgmtConfigurationSuccess: (state, action) => {
            state.configuration.isLoading = false;
            state.configuration.error = null;
            state.configuration.data = action.payload.data;
        },
        OrderMgmtConfigurationError: (state, action) => {
            state.configuration.isLoading = false;
            state.configuration.error = action.payload;
        },
        OrderMgmtConfigurationReset: (state) => {
            state.configuration = OrderManagementInitialState.configuration;
        },

        OrderMgmtCreateConfigurationRequesting: (state) => {
            state.createConfiguration.isLoading = true;
        },
        OrderMgmtCreateConfigurationSuccess: (state, action) => {
            state.createConfiguration.isLoading = false;
            state.createConfiguration.error = null;
            state.createConfiguration.data = action.payload.data;
        },
        OrderMgmtCreateConfigurationError: (state, action) => {
            state.createConfiguration.isLoading = false;
            state.createConfiguration.error = action.payload;
        },
        OrderMgmtCreateConfigurationReset: (state) => {
            state.createConfiguration = OrderManagementInitialState.createConfiguration;
        },

        OrderMgmtDeleteConfigurationRequesting: (state) => {
            state.deleteConfiguration.isLoading = true;
        },
        OrderMgmtDeleteConfigurationSuccess: (state) => {
            state.deleteConfiguration.isLoading = false;
            state.deleteConfiguration.error = null;
            state.deleteConfiguration.data = "deleted";
        },
        OrderMgmtDeleteConfigurationError: (state, action) => {
            state.deleteConfiguration.isLoading = false;
            state.deleteConfiguration.data = null;
            state.deleteConfiguration.error = action.payload;
        },
        OrderMgmtDeleteConfigurationReset: (state) => {
            state.deleteConfiguration = OrderManagementInitialState.deleteConfiguration;
        },
    },
});

// Async Actions

export const OrderMgmtConfigurationAPI = () => async (dispatch) => {
    dispatch(OrderMgmtConfigurationRequesting());
    apiService
        .get(endPoints.integration.orderManagement.config, {})
        .then((response) => {
            dispatch(OrderMgmtConfigurationSuccess(response.data));
        })
        .catch((error) => {
            dispatch(OrderMgmtConfigurationError(formatAxiosErrorMessage(error)));
        });
};

export const OrderMgmtCreateConfigurationAPI = (data) => async (dispatch) => {
    dispatch(OrderMgmtCreateConfigurationRequesting());
    apiService
        .post(endPoints.integration.orderManagement.config, data)
        .then((response) => {
            dispatch(OrderMgmtCreateConfigurationSuccess(response.data));
        })
        .catch((error) => {
            dispatch(OrderMgmtCreateConfigurationError(formatAxiosErrorMessage(error)));
        });
};

export const OrderMgmtDeleteConfigurationAPI = (id) => async (dispatch) => {
    dispatch(OrderMgmtDeleteConfigurationRequesting());
    apiService
        .delete(apiUrlBuilder(endPoints.integration.orderManagement.config + `${id}/order-management/config/`), {})
        .then((response) => {
            dispatch(OrderMgmtDeleteConfigurationSuccess());
        })
        .catch((error) => {
            dispatch(OrderMgmtDeleteConfigurationError(formatAxiosErrorMessage(error)));
        });
};

// Export Actions
export const {
    OrderMgmtConfigurationRequesting,
    OrderMgmtConfigurationSuccess,
    OrderMgmtConfigurationError,
    OrderMgmtConfigurationReset,

    OrderMgmtCreateConfigurationRequesting,
    OrderMgmtCreateConfigurationSuccess,
    OrderMgmtCreateConfigurationError,
    OrderMgmtCreateConfigurationReset,

    OrderMgmtDeleteConfigurationRequesting,
    OrderMgmtDeleteConfigurationSuccess,
    OrderMgmtDeleteConfigurationError,
    OrderMgmtDeleteConfigurationReset,
} = OrderManagementSlice.actions;

// Selector
export const OrderManagementState = (state) => state.orderManagement;

// Reducer
export default OrderManagementSlice.reducer;
